// extracted by mini-css-extract-plugin
export default {"container":"innerHeader_container__DUhG7","total":"innerHeader_total__Q1YlL"};